const roleLabelsByName: Readonly<Record<string, string>> = {
  User: 'Пользователь',
  Admin: 'Администратор',
  SuperAdmin: 'Администратор',
  ClinicAdmin: 'Администратор клиники',
  Moderator: 'Модератор',
};

export const ROLE_LABELS = roleLabelsByName;

export const getRoleLabel = (role: string): string =>
  roleLabelsByName[role] ?? role;

export const getRoleLabels = (roles: readonly string[]): string =>
  roles.map(getRoleLabel).join(', ');
